// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .src-js-traveler-register-travelerRegisterForm-module__emailText--XzMVg {
    font-weight: bold;
  }
  
  .src-js-traveler-register-travelerRegisterForm-module__usernameText--j_gyF {
    margin-left: 16px;
  }

  .src-js-traveler-register-travelerRegisterForm-module__modalButton--fD3nz {
    margin-top: 25px;
  }

  .src-js-traveler-register-travelerRegisterForm-module__boxPadding--PW4pz {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .src-js-traveler-register-travelerRegisterForm-module__flexCenter--j5VNM {
    display: flex;
    flex-direction: column;
    align-items: center;
  }`, "",{"version":3,"sources":["webpack://./src/js/traveler/register/travelerRegisterForm.module.css"],"names":[],"mappings":"EAAE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB","sourcesContent":["  .emailText {\n    font-weight: bold;\n  }\n  \n  .usernameText {\n    margin-left: 16px;\n  }\n\n  .modalButton {\n    margin-top: 25px;\n  }\n\n  .boxPadding {\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n\n  .flexCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emailText": `src-js-traveler-register-travelerRegisterForm-module__emailText--XzMVg`,
	"usernameText": `src-js-traveler-register-travelerRegisterForm-module__usernameText--j_gyF`,
	"modalButton": `src-js-traveler-register-travelerRegisterForm-module__modalButton--fD3nz`,
	"boxPadding": `src-js-traveler-register-travelerRegisterForm-module__boxPadding--PW4pz`,
	"flexCenter": `src-js-traveler-register-travelerRegisterForm-module__flexCenter--j5VNM`
};
export default ___CSS_LOADER_EXPORT___;
